import React from 'react'
import { Edit, SimpleForm, TextInput, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { Grid } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const ReservationEdit = (props) => {
  const translate = useTranslate()

  return (
    <Edit title='Reservation' {...props} actions={null}>
      <CardCommon title={translate('ra.title.update_reservation')} actions={null}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.status')}>
              <TextInput source='status' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.create_at')}>
              <TextInput source='create_at' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.update_at')}>
              <TextInput source='update_at' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.work_unit')}>
              <TextInput source='work_unit' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.business_unit')}>
              <TextInput source='business_unit' label={false} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
